import { render, staticRenderFns } from "./ProjectCases.vue?vue&type=template&id=56d2bb3c&scoped=true"
import script from "./ProjectCases.vue?vue&type=script&lang=js"
export * from "./ProjectCases.vue?vue&type=script&lang=js"
import style0 from "./ProjectCases.vue?vue&type=style&index=0&id=56d2bb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d2bb3c",
  null
  
)

export default component.exports